import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import { createCachedLoadReCaptchaScriptFn } from './script';

/**
 * reCAPTCHA doesn't allow you to render a CAPTCHA challenge within a
 * populated element so we make a temporary empty one.
 *
 * This enables this method to be able to render an element from anywhere
 * for a better developer experience.
 */
var withinTemporaryDiv = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(element, onDivMounted) {
    var reCaptchaContainer, result;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            reCaptchaContainer = document.createElement('div');
            /*
             * The only reason we add this to the element and not, say, in the document
             * body is because reCAPTCHA puts the CAPTCHA challenge next to the element
             * that it was initiated from for a better UX.
             */

            element.appendChild(reCaptchaContainer);
            _context.next = 4;
            return onDivMounted(reCaptchaContainer);

          case 4:
            result = _context.sent;
            element.removeChild(reCaptchaContainer);
            return _context.abrupt("return", result);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function withinTemporaryDiv(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
/**
 * ReCaptcha doesn't let you run .render(...) twice, so to avoid doing so without
 * too much extra code, just store mappings between each element and and queue of token promise resolvers.
 *
 * Not ideal but at least we don't have to track state about whether we have or haven't rendered the state anywhere else this way.
 */


var createRequestOrRetrigger = function createRequestOrRetrigger(onRequestChallenge) {
  var renderedElementToReTrigger = new WeakMap();

  var requestOrRetrigger = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(grecaptcha, siteKey, element, parameters) {
      var _onRequestChallenge, tokenResultPromise, retriggerReCaptcha, token;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!renderedElementToReTrigger.has(element)) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return", renderedElementToReTrigger.get(element)());

            case 2:
              _onRequestChallenge = onRequestChallenge(grecaptcha, siteKey, element, parameters), tokenResultPromise = _onRequestChallenge.tokenResultPromise, retriggerReCaptcha = _onRequestChallenge.retriggerReCaptcha;
              renderedElementToReTrigger.set(element, retriggerReCaptcha);
              _context2.next = 6;
              return tokenResultPromise;

            case 6:
              token = _context2.sent;
              renderedElementToReTrigger.delete(element);
              return _context2.abrupt("return", token);

            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function requestOrRetrigger(_x3, _x4, _x5, _x6) {
      return _ref2.apply(this, arguments);
    };
  }();

  return requestOrRetrigger;
};

export var createReCaptchaClientFactory = function createReCaptchaClientFactory(scriptInfo) {
  var loadReCaptcha = createCachedLoadReCaptchaScriptFn(scriptInfo);
  var requestOrRetriggerChallenge = createRequestOrRetrigger(scriptInfo.triggerReCaptchaChallenge);

  var createReCaptchaClient = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var options,
          grecaptcha,
          requestCaptchaChallengeForElement,
          _args4 = arguments;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              options = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : {};
              _context4.next = 3;
              return loadReCaptcha(options);

            case 3:
              grecaptcha = _context4.sent;

              requestCaptchaChallengeForElement = /*#__PURE__*/function () {
                var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(anchoredElement, siteKey, parameters) {
                  var token;
                  return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          _context3.next = 2;
                          return withinTemporaryDiv(anchoredElement, function (reCaptchaContainer) {
                            return requestOrRetriggerChallenge(grecaptcha, siteKey, reCaptchaContainer, parameters);
                          });

                        case 2:
                          token = _context3.sent;
                          return _context3.abrupt("return", token);

                        case 4:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3);
                }));

                return function requestCaptchaChallengeForElement(_x7, _x8, _x9) {
                  return _ref4.apply(this, arguments);
                };
              }();

              return _context4.abrupt("return", {
                requestCaptchaChallengeForElement: requestCaptchaChallengeForElement
              });

            case 6:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function createReCaptchaClient() {
      return _ref3.apply(this, arguments);
    };
  }();

  return createReCaptchaClient;
};